import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    notifications: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    notifications: [],
};

export const LOAD_NOTIFICATION_LIST = 'LOAD_NOTIFICATION_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    
    reset({ commit, getters, dispatch, state }) {
        state.notifications = [];

        state.lastMeta = {
            page: 0,
            pageSize: 0,
            totalCount: 0,
            totalPages: 0
        };
    },

    loadData({ commit, getters, dispatch, rootState }, page = 1) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(LOAD_NOTIFICATION_LIST)
                .select()
                .from('notifications')
                .fileds$((_: any) => {
                    return {
                        id: 'notifications.id',
                        code: 'notifications.code',
                        body: 'notifications.body',
                        is_read: 'notifications.is_read',
                        created_at: 'notifications.created_at',
                    }
                })
                .order((_: any) => {
                    return [
                        _.desc(['notifications.created_at']),
                    ];
                })
                .where((_: any) => _.eq('notifications.actor_id', _.const((rootState as any).ubic.actor.document.id)))
                .page(page),
            ]).then(((result: ServerResult) => {
                commit('SET_NOTIFICATIONS_LIST', result.getOperation(LOAD_NOTIFICATION_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    loadMore({ commit, getters, dispatch, state }) {
        return dispatch('loadData', state.lastMeta.page + 1)
    },

    markNotificationAsRead({ commit, getters, dispatch, rootState }, id) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                id ?
                    vm.$q('MARK_NOTIFICATION_AS_READ').update(id, {is_read: true}) :
                    vm.$q('MARK_NOTIFICATION_AS_READ').raw('notifications.read_all').action({})
            ]).then(((result: ServerResult) => {
                if(!result.getOperation('MARK_NOTIFICATION_AS_READ').hasError()) {
                    commit('MARK_AS_READ_SUCCESS', id)
                }
            }));
        })
    },

};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_NOTIFICATIONS_LIST(state, data) {
        state.notifications = [
            ...state.notifications,
            ...data.documents
        ];

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },

    MARK_AS_READ_SUCCESS(state, id) {
        if (id) {
            const index = state.notifications.findIndex((notify: any) => notify.id == id);
            state.notifications[index].is_read = true;
        } else {
            state.notifications = state.notifications.map((notify: any) => {
                return {
                    ...notify,
                    is_read: true
                }
            })
        }
        
    }
};

const getters = {

};

export const STORE_KEY = '$_notifications';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
